import React from 'react';

const onlinepayment = () => {
  return (
    <div>
      onlinepayment
    </div>
  );
}

export default onlinepayment;
